import React from "react";
import { SectionHead } from "./SectionHead";
type Feature = {
  icon: string;
  title: string;
  text: string;
};
type FeatureGridProps = {
  kicker: string;
  title: string;
  subtitle: string;
  items: Feature[];
};
export function FeatureGrid({
  kicker,
  title,
  subtitle,
  items
}: FeatureGridProps) {
  return <section className="card" data-id="element-38" data-mp="21nt6yhh5ieeu">
      <SectionHead kicker={kicker} title={title} subtitle={subtitle} data-id="element-39" data-mp="21njqpllwrlmc" />
      <div className="bg2" data-id="element-40" data-mp="1dy76zrsyfv5s">
        {items.map(f => <div className="ben" key={f.title} data-id="element-41" data-mp="18y2sg7blxai7">
            <div className="bic" aria-hidden="true" data-id="element-42" data-mp="18ze56wn15slg">
              {f.icon}
            </div>
            <div data-id="element-43" data-mp="1myx4r11rzvm5">
              <h3 data-id="element-44" data-mp="1mzf3q5ftonxr">{f.title}</h3>
              <p data-id="element-45" data-mp="1hyr5ozt6f6u1">{f.text}</p>
            </div>
          </div>)}
      </div>
    </section>;
}